var map = {
	"./blackGold/header/reload.png": 72248,
	"./brownGold/header/reload.png": 52191,
	"./darkBlue/header/reload.png": 94569,
	"./greenYellow/header/reload.png": 27966,
	"./redGold/header/reload.png": 27494,
	"./skyBlue/header/reload.png": 67474,
	"./whiteGold/header/reload.png": 51448,
	"./yellowWhite/header/reload.png": 83950
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33301;